<template>
  <div class="w-full flex gap-2">
    <button v-if="examination.isStarred" @click="() => {starExamination()}"
            class="text-yellow-500 p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star" width="24"
            height="24"/>
    </button>
    <button v-if="!examination.isStarred" @click="() => {starExamination()}"
            class="p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
      <Icon icon="material-symbols:star-outline" width="24"
            height="24"/>
    </button>
    {{examination.externalID}}
    <ExamTypeBadges :examination="examination"/>
  </div>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {Icon} from '@iconify/vue';
import Examination from "@/models/customer/Examination";
import ExamTypeBadges from './ExamTypeBadges.vue'

export default defineComponent({
  setup() {
    const examination = ref<Examination>(new Examination())
    return {
      examination,
    }
  },
  components: {
    Icon,
    ExamTypeBadges
  },
  mounted() {
    /* @ts-ignore */
    this.examination = Examination.from(this.params?.data)
  },
  methods: {
    notify() {
      /* @ts-ignore */
      this.params.reload();
    },
    async starExamination() {
      try {
        const res = await this.$http.put<Examination>(Examination.ENDPOINT + `/${this.examination.id}/star`, this.examination);
        this.examination = Examination.from(res)
        this.notify();
      } catch (e) {
        console.log(e)
      }
    }
  },
})
</script>
